import { useState } from 'react';

import { setupForDark } from '@theme';
import classNames from 'classnames';

export interface TabSpec {
  label: string;
  testId?: string;
}

export default function Tabs({
  tabs,
  onTabChange,
  bottomBorder = true
}: {
  tabs: TabSpec[];
  onTabChange: (tab: string) => void;
  bottomBorder?: boolean;
}) {
  const [active, setActive] = useState(tabs[0]?.label);

  const onClick = (label: string) => {
    setActive(label);
    onTabChange(label);
  };

  return (
    <div
      className={classNames(
        'mb-[-1px]',
        bottomBorder ? 'border-b-[1px]' : '',
        setupForDark('border-secondary')
      )}
    >
      <div
        className={classNames(
          'flex flex-row gap-xl items-end justify-start',
          'mx-xl max-w-full overflow-y-auto scrollbar-none'
        )}
      >
        {tabs.map(({ label, testId }) => (
          <div
            data-testid={testId}
            className={classNames({
              C1M: true,
              'border-b-[2px] pb-xs': active === label,
              'pb-xs mb-[2px]': active !== label,
              'hover:cursor-pointer w-full text-center': true,
              [setupForDark('text-input-active border-b-input-active')]: active === label,
              [setupForDark('text-tertiary border-b-tertiary')]: active !== label
            })}
            onClick={() => onClick(label)}
            key={label}
          >
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}
